import { PipeTransform } from '@angular/core';
var TitleCasePipe = /** @class */ (function () {
    function TitleCasePipe() {
    }
    TitleCasePipe.prototype.transform = function (value) {
        if (!value) {
            return '';
        }
        return value.replace(/[A-Za-z]+\s*/g, function (val) {
            if (/^[Ii]+$/.test(val)) {
                return val.toUpperCase();
            }
            else {
                return val[0].toUpperCase() + val.substr(1).toLowerCase();
            }
        });
    };
    return TitleCasePipe;
}());
export { TitleCasePipe };
